import { styled } from '@mui/material/styles';

interface StyledIconProps {
  gap?: string;
  textTransform?: 'none' | 'uppercase' | 'capitalize';
  color?: string;
  justifyContent?: 'flex-start' | 'center' | 'flex-end';
}

/**
 * You can use this styled component to wrap a text (label) and an icon.
 * Especially useful in a list of items with text and state, where variations
 * in the state can be depicted by the icon by updating its fill prop.
 */
const StyledIcon = styled('div')<StyledIconProps>`
  display: flex;
  flex-direction: row;
  gap: ${({ gap }) => gap || '1rem'};
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  line-height: 1rem;
  text-transform: ${({ textTransform }) => textTransform || 'none'};
  color: ${({ color }) => color || 'var(--primary-text-color)'};
  align-items: center;
`;

export default StyledIcon;
